// libs
import React, { memo, Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Container, ProductTagsContainer, Seperator } from './styles';

// components
import ProductTag from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductTag';
import Badge from 'shared/layouts/DetailsPage/components/ProductInfo/components/Badge';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// helpers
import { getWebAppType } from 'shared/helpers/deviceType/webAppType';
import { WEB_APP_TYPE } from 'shared/constants';

// defs
import { IMultitag } from './types';

function Multitag({ productTags, badge }: IMultitag) {
  const isMobile = getWebAppType() === WEB_APP_TYPE.MWEB;
  const { mobile, desktop } = useRemoteConfig('plpBadge');
  const showBadge = isMobile ? mobile : desktop;
  const { hiddenTags = [] } = useRemoteConfig('pdpProductTags');

  const filteredTags = hiddenTags.length
    ? productTags.filter(
      (tag) => !hiddenTags.some((hidden) => tag.toLowerCase() === hidden.toLowerCase())
    )
    : productTags;
  const noOfTags = filteredTags.length;

  if (isEmpty(badge) && isEmpty(filteredTags)) {
    return null;
  }

  return (
    <Container data-test="multitag-container">
      {showBadge && badge && <Badge value={badge} />}
      <ProductTagsContainer>
        {filteredTags.map((tag, i) => {
          return (
            <Fragment key={`product-tag-${tag}`}>
              <ProductTag productTag={tag} data-test="product-tag" />
              {noOfTags > 1 && i < noOfTags - 1 && <Seperator />}
            </Fragment>
          );
        })}
      </ProductTagsContainer>
    </Container>
  );
}

export default memo(Multitag);
